export default __webpack_public_path__ + "static/bentoSectionBg4Mob-ab38d000d980147fc1f87ff66434b871.webp";